import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const fetchSimilarProducts = async (currentProductId, category) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const allProducts = {
                1: { id: 1, name: "Starshine Ring", productCode: "PT65001", price: 22000, category: "Rings", image: "/assets/images/binstock/Ring1.png" },
                2: { id: 2, name: "Aurora Ring", productCode: "PT65002", price: 25000, category: "Rings", image: "/assets/images/binstock/Ring2.png" },
                3: { id: 3, name: "Effulgent Ring", productCode: "PT65003", price: 28000, category: "Rings", image: "/assets/images/binstock/Ring3.png" },
                4: { id: 4, name: "Nimbus Ring", productCode: "PT65004", price: 21000, category: "Rings", image: "/assets/images/binstock/Ring4.png" },
                5: { id: 5, name: "Moonlit Ring", productCode: "PT65005", price: 24500, category: "Rings", image: "/assets/images/binstock/Ring5.png" },
                6: { id: 6, name: "Celest Ring", productCode: "PT65006", price: 23500, category: "Rings", image: "/assets/images/binstock/Ring6.png" },
                7: { id: 7, name: "Skyward Ring", productCode: "PT65007", price: 26000, category: "Rings", image: "/assets/images/binstock/Ring7.png" },
                8: { id: 8, name: "Sacred Stud Earring", productCode: "PT65008", price: 18000, category: "Earrings", image: "/assets/images/binstock/Ring8.png" },
                9: { id: 9, name: "Pinnacle Stud Earring", productCode: "PT65009", price: 17500, category: "Earrings", image: "/assets/images/binstock/Ring9.png" },
                10: { id: 10, name: "Clarity Stud Earring", productCode: "PT65010", price: 17000, category: "Earrings", image: "/assets/images/binstock/Ring10.png" },
                11: { id: 11, name: "Gaze Stud Earring", productCode: "PT65011", price: 18500, category: "Earrings", image: "/assets/images/binstock/Ring11.png" },
                12: { id: 12, name: "Crown Stud Earring", productCode: "PT65012", price: 19000, category: "Earrings", image: "/assets/images/binstock/Ring12.png" },
                13: { id: 13, name: "Divine Stud Earring", productCode: "PT65013", price: 18200, category: "Earrings", image: "/assets/images/binstock/Ring13.png" },
                14: { id: 14, name: "Linara Stud Earring", productCode: "PT65014", price: 17800, category: "Earrings", image: "/assets/images/binstock/Ring14.png" },
                15: { id: 15, name: "Oren Stud Earring", productCode: "PT65015", price: 17900, category: "Earrings", image: "/assets/images/binstock/Ring15.png" },
                16: { id: 16, name: "Zest Stud Earring", productCode: "PT65016", price: 16800, category: "Earrings", image: "/assets/images/binstock/Ring16.png" },
                17: { id: 17, name: "Bold Ring", productCode: "PT65017", price: 29000, category: "Rings", image: "/assets/images/binstock/Ring17.png" },
                18: { id: 18, name: "Velvet Ring", productCode: "PT65018", price: 25500, category: "Rings", image: "/assets/images/binstock/Ring18.png" },
                19: { id: 19, name: "Glimmer Ring", productCode: "PT65019", price: 24800, category: "Rings", image: "/assets/images/binstock/Ring19.png" },
                20: { id: 20, name: "Jewel Ring", productCode: "PT65020", price: 24000, category: "Rings", image: "/assets/images/binstock/Ring20.png" },
            };

            const similarProducts = Object.values(allProducts)
                .filter(product =>
                    product.category === category &&
                    product.id !== currentProductId
                )
                .slice(0, 8);

            resolve(similarProducts);
        }, 300);
    });
};

const SimilarProductsSlider = ({ currentProductId, category }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [perView, setPerView] = useState(() => {
        if (typeof window !== "undefined") {
            const width = window.innerWidth;
            if (width < 576) return 1;
            if (width < 768) return 2;
            if (width < 992) return 3;
        }
        return 4;
    });

    const [index, setIndex] = useState(perView);
    const autoMs = 4000;

    const viewportRef = useRef(null);
    const [transitioning, setTransitioning] = useState(true);
    const [hover, setHover] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const loadSimilarProducts = async () => {
            try {
                setLoading(true);
                const similarProducts = await fetchSimilarProducts(currentProductId, category);
                setProducts(similarProducts);
            } catch (error) {
                console.error("Error loading similar products:", error);
            } finally {
                setLoading(false);
            }
        };

        if (currentProductId && category) {
            loadSimilarProducts();
        }
    }, [currentProductId, category]);

    const slides = [
        ...products.slice(-perView),
        ...products,
        ...products.slice(0, perView),
    ];

    const updatePerView = () => {
        const width = window.innerWidth;
        if (width < 576) {
            setPerView(1);
        } else if (width < 768) {
            setPerView(2);
        } else if (width < 992) {
            setPerView(3);
        } else {
            setPerView(5);
        }
    };

    useEffect(() => {
        updatePerView();
        const handleResize = () => updatePerView();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setIndex(perView);
    }, [perView]);

    const next = () => setIndex((i) => i + 1);
    const prev = () => setIndex((i) => i - 1);

    useEffect(() => {
        if (products.length <= perView) return;
        const id = setInterval(next, autoMs);
        return () => clearInterval(id);
    }, [perView, products.length]);

    useEffect(() => {
        if (index === slides.length - perView) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(perView);
            }, 600);
        }
        if (index === 0) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(slides.length - perView * 2);
            }, 600);
        }
    }, [index, slides.length, perView]);

    useEffect(() => {
        if (!transitioning) {
            const id = setTimeout(() => setTransitioning(true), 50);
            return () => clearTimeout(id);
        }
    }, [transitioning]);

    const handleProductClick = (productId) => {
        navigate(`/binstock/${productId}`);
    };

    if (loading) {
        return (
            <div className="row mt-5">
                <div className="col-12">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h5 className="fw-bold mb-2 text-center text-primary">Similar Products</h5>
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (products.length === 0) {
        return null;
    }


    return (
        <div className="row mt-5">
            <div className="col-12">
                <div className="card shadow-sm border-0 shadow-none">
                    <div className="card-body bg-white">
                        <h5 className="fw-bold mb-2 text-center text-primary">Similar Products</h5>

                        <div
                            className="similar-products-carousel position-relative"
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                        >
                            {/* Navigation Arrows */}
                            {products.length > perView && (
                                <>
                                    <button
                                        className="sp-arrow sp-left"
                                        onClick={prev}
                                        aria-label="Previous"
                                    >
                                        <i className="bx bx-chevron-left fs-1 text-primary"></i>
                                    </button>

                                    <button
                                        className="sp-arrow sp-right"
                                        onClick={next}
                                        aria-label="Next"
                                    >
                                        <i className="bx bx-chevron-right fs-1 text-primary"></i>
                                    </button>
                                </>

                            )}

                            {/* Carousel Viewport */}
                            <div className="sp-viewport" ref={viewportRef}>
                                <div
                                    className="sp-track"
                                    style={{
                                        transform: `translateX(-${(index * 100) / perView}%)`,
                                        transition: transitioning ? "transform 0.6s ease" : "none"
                                    }}
                                >
                                    {slides.map((product, idx) => (
                                        <div
                                            className="sp-slide"
                                            key={idx}
                                            style={{ width: `${100 / perView}%` }}
                                        >
                                            <div
                                                className="card h-100 m-0"
                                                onClick={() => handleProductClick(product.id)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img
                                                    src={product.image}
                                                    className="card-img-top"
                                                    alt={product.name}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = "/assets/images/binstock/no-image.jpg";
                                                    }}
                                                />
                                                {/*<div className="card-body text-center bg-white">*/}
                                                {/*    <h6 className="card-title text-dark mb-2">{product.name}</h6>*/}
                                                {/*    <p className="card-text text-primary fw-bold mb-1">*/}
                                                {/*        <i className="bx bx-rupee"></i>{product.price?.toLocaleString()}*/}
                                                {/*    </p>*/}
                                                {/*    <small className="text-muted">{product.productCode}</small>*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .similar-products-carousel {
                    position: relative;
                    overflow: hidden;
                }
                
                .sp-viewport {
                    overflow: hidden;
                    width: 100%;
                }
                
                .sp-track {
                    display: flex;
                    transition: transform 0.6s ease;
                }
                
                .sp-slide {
                    flex: 0 0 auto;
                    padding: 0 5px;
                }
                
                .sp-arrow {
                    position: absolute;
                    top: 50%;
                      background: none;
                      border: none;
                      outline: none;
                    transform: translateY(-50%);
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 10;
                    transition: all 0.3s ease;
                }
                                
                .sp-left {
                    left: 10px;
                }
                
                .sp-right {
                    right: 10px;
                }
                
                .sp-indicators {
                    display: flex;
                    justify-content: center;
                    gap: 8px;
                }
                
                .sp-indicator {
                    width: 10px;
                    height: 10px;
                    background: #dee2e6;
                    transition: background 0.3s ease;
                    cursor: pointer;
                }
                
                .sp-indicator.active {
                    background: #007bff;
                }
                
                .cursor-pointer {
                    cursor: pointer;
                }
                
                @media (max-width: 576px) {
                    .sp-arrow {
                        width: 35px;
                        height: 35px;
                    }
                    
                    .sp-arrow svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default SimilarProductsSlider;